import React from 'react';
import cx from 'classnames';
import { allowedSizes } from './constants';
import fontStyles from './BrandFont.module.scss';
import styles from './BrandIcon.module.scss';
const BrandIcon = ({ name, className, size = 'lg', ...rest }) => (React.createElement("span", { "data-icon": name, style: {
        fontSize: typeof size === 'number' ? `${String(size)}px` : undefined,
    }, className: cx(styles.brandIcon, fontStyles[`tt-icon-brand-${name}`], {
        [styles[`font-size-${String(size)}`]]: typeof size !== 'number' && allowedSizes.includes(size),
    }, className), ...rest }, Array(11)
    .fill(0)
    .map((_, i) => (React.createElement("span", { 
    // eslint-disable-next-line react/no-array-index-key
    key: i, className: cx(fontStyles[`tt-icon-brand-${name}`], fontStyles[`path${String(i + 1)}`]) })))));
export default BrandIcon;
